export default __webpack_public_path__ + "media/zurb/img/events/wired/second-harvest/second-harvest-photos-73130cf6fb797b61d03c4229a2620e80.png";